import ApiService from "@/store/api-service";
import {
	UPLOAD_MEDIA_TO_SERVER,
	SHOW_ALERT,
	RESET_UPLOAD_MODULE
} from "@/store/action-types";
import {
	imageUploadingSuccess,
	resetUploadModule,
	setDefaultUploadedDocuments
} from "@/store/mutation-types";
import { DEFAULT_ERROR_MESSAGE } from "@/store/config";
import { UPLOAD_MEDIA_API } from "../../../config";

const state = {
	IDProof: null,
	GSTCertificate: null,
	agreement: null,
	COI: null
};

const initialState = Object.assign({}, state);

const actions = {
	[UPLOAD_MEDIA_TO_SERVER.action]: ({ commit, dispatch }, { key, file }) => {
		// console.log("payload: ", payload);
		// return;
		let formData = new FormData();
		formData.append("userfile", file);
		const endpoint = UPLOAD_MEDIA_API;
		const requestPayload = formData;
		const headers = {
			"X-SHARECHAT-CALLER": "jeet11-retail-tool"
		};
		return ApiService.post(endpoint, requestPayload, { headers })
			.then(data => {
				// console.log("data :", data, Date.now());
				// debugger;
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (typeof data === "object") {
					// if (type === "changeDp") {
					// 	// dispatch("UPDATE_PROFILE_DATA", {
					// 	// 	payload: {
					// 	// 		message: {
					// 	// 			p: data.fileUrl,
					// 	// 			t: data.thumbUrl
					// 	// 		},
					// 	// 		source: type
					// 	// 	},
					// 	// 	ref
					// 	// });
					// 	return;
					// } else if (type === "changeCover") {
					// 	// dispatch("UPDATE_PROFILE_DATA", {
					// 	// 	payload: {
					// 	// 		message: {
					// 	// 			coverPic: data.fileUrl
					// 	// 		},
					// 	// 		source: type
					// 	// 	},
					// 	// 	ref
					// 	// });
					// 	return;
					// } else {
					commit(imageUploadingSuccess, {
						key,
						value: data.fileUrl
					});
					// debugger;
					return data;
					// }
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[RESET_UPLOAD_MODULE.action]: ({ commit }) => {
		commit(resetUploadModule);
	}
};

const mutations = {
	[imageUploadingSuccess](state, { key, value }) {
		state[key] = value;
	},
	[setDefaultUploadedDocuments](state, payload) {
		const {
			GSTCertificate = null,
			IDProof = null,
			agreement = null,
			COI = null
		} = payload;
		state.GSTCertificate = GSTCertificate;
		state.IDProof = IDProof;
		state.agreement = agreement;
		state.COI = COI;
	},
	[resetUploadModule](state) {
		Object.keys(initialState).map(key => {
			state[key] = initialState[key];
		});
	}
};

export default {
	namespaced: true,
	state,
	actions,
	mutations
};
